module.exports = __webpack_public_path__ + "img/mf.9411da91.jpg";